import React from 'react';

import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import JobProfileDetailCore from './JobProfileDetailCore';
import JobProfileDetailDimensions from './JobProfileDetailDimensions';
import JobProfileHintsContainer from './job-profile-hints/JobProfileHintsContainer';
import { Loading } from '../../../components/Loading';
import { DeleteTextButton } from '../../../components/button/ActionButton';
import { Gr8piFormattedDate } from '../../../components/Gr8piFormattedDateTime';
import { intlShape } from '../../../components/prop-types';

const messages = defineMessages({
  deleteJobProfile: { id: 'del_header.job', defaultMessage: 'Delete Job Profile' },
});

const JobProfileDetail = (props) => {
  const {
    jobProfileCore,
    jobProfileDimensions,
    suggestions,
    currentAccount,
    selectedHints,
    jobId,
    intl: { formatMessage },
  } = props;
  const { dataLoading, onDeleteJobProfile } = props;
  const {
    hintsCS, hintsJPS, hintsSJL, onHintsSJL, sectionEditable, toggleSectionEditable,
  } = props;
  const { onEditDimensions, onSuggestJobProfile } = props;
  const { onAddCSRespondent, onToggleCS, onHintsCS } = props;
  const { onToggleJPS, onHintsJPS } = props;
  if (jobProfileCore.loading || !jobProfileCore.account || !jobProfileCore.account.jobProfile) {
    return <Loading />;
  }
  const { jobProfile } = jobProfileCore.account;
  const nameJobProfile = jobProfile.name;
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <div className="p-grid">
            <div className="p-md-6 v-center">
              <span>
                <FormattedMessage id="attrs.added.verbose" defaultMessage="Added on" />
                &nbsp;
                <strong>
                  <Gr8piFormattedDate dateValue={jobProfile.createdOn} />
                </strong>
                &nbsp;
                <FormattedMessage id="by" defaultMessage="by" />
                {'  '}
                {jobProfile.createdBy && (
                  <span>
                    {jobProfile.createdBy.firstName}
                    {' '}
                    {jobProfile.createdBy.lastName}
                  </span>
                )}
              </span>
            </div>
            <div className="p-md-6 align-right">
              <DeleteTextButton
                position="right"
                onClick={onDeleteJobProfile}
                text={formatMessage(messages.deleteJobProfile)}
              />
            </div>
            <div className="p-sm-12 p-md-7">
              <Panel>
                {jobProfileCore.loading ? <div /> : <JobProfileDetailCore jobProfile={jobProfile} />}

                {jobProfileDimensions.loading
                || !jobProfileDimensions.account
                || !jobProfileDimensions.account.jobProfile ? (
                  <div />
                  ) : (
                    <JobProfileDetailDimensions
                      suggestions={suggestions}
                      jobProfile={jobProfileDimensions.account.jobProfile}
                      currentAccount={currentAccount}
                      hintsCS={hintsCS}
                      hintsJPS={hintsJPS}
                      hintsSJL={hintsSJL}
                      dataLoading={dataLoading}
                      onEdit={onEditDimensions}
                      isEdit={sectionEditable}
                      toggleEdit={toggleSectionEditable}
                    />
                  )}
              </Panel>
            </div>

            <div className="p-sm-12 p-md-5">
              <JobProfileHintsContainer
                jobProfile={jobProfile}
                currentAccount={currentAccount}
                onHintsCS={onHintsCS}
                onToggleCS={onToggleCS}
                onAddCSRespondent={onAddCSRespondent}
                hintsCS={hintsCS}
                onSuggestJobProfile={onSuggestJobProfile}
                dataLoading={dataLoading}
                onHintsSJL={onHintsSJL}
                onToggleJPS={onToggleJPS}
                onHintsJPS={onHintsJPS}
                hintsJPS={hintsJPS}
                jobId={jobId}
                nameJobProfile={nameJobProfile}
                selectedHints={selectedHints}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

JobProfileDetail.propTypes = {
  intl: intlShape.isRequired,
  jobProfileCore: PropTypes.objectOf(PropTypes.any).isRequired,
  jobProfileDimensions: PropTypes.objectOf(PropTypes.any).isRequired,
  suggestions: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  dataLoading: PropTypes.bool.isRequired,
  selectedHints: PropTypes.objectOf(PropTypes.any).isRequired,
  hintsCS: PropTypes.objectOf(PropTypes.any),
  hintsJPS: PropTypes.objectOf(PropTypes.any),
  hintsSJL: PropTypes.objectOf(PropTypes.any),
  onHintsSJL: PropTypes.func.isRequired,
  sectionEditable: PropTypes.bool.isRequired,
  toggleSectionEditable: PropTypes.func.isRequired,
  onDeleteJobProfile: PropTypes.func.isRequired,
  onEditDimensions: PropTypes.func.isRequired,
  onSuggestJobProfile: PropTypes.func.isRequired,
  onAddCSRespondent: PropTypes.func.isRequired,
  onToggleCS: PropTypes.func.isRequired,
  onHintsCS: PropTypes.func.isRequired,
  onToggleJPS: PropTypes.func.isRequired,
  onHintsJPS: PropTypes.func.isRequired,
};

JobProfileDetail.defaultProps = {
  hintsCS: {},
  hintsJPS: {},
  hintsSJL: {},
};

export default JobProfileDetail;
